/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_NDC_PAYMENT_DISPLAY = 'REFRESH_NDC_PAYMENT_DISPLAY';
export const SET_SELECTED_INPUT_NDC_PAYMENT = 'SET_SELECTED_INPUT_NDC_PAYMENT';

export const GET_NDC_PAYMENTS_MAX_QUARTER = 'GET_NDC_PAYMENTS_MAX_QUARTER';
export const GET_NDC_PAYMENT_RESULT_GRID = 'GET_NDC_PAYMENT_RESULT_GRID';
export const REFRESH_NDC_PAYMENT = 'REFRESH_NDC_PAYMENT';

export const IS_LOADING_NDC_PAYMENT = 'IS_LOADING_NDC_PAYMENT';
